import { FormattedMessage } from 'react-intl'
import { TouchableOpacity } from 'react-native'
import styled from 'styled-components'
import Icon from '../../../elements/images/Icon'
import { Text } from '../../../elements/typography'
import messages from './messages'

const Container = styled(TouchableOpacity).attrs({ activeOpacity: 1 })`
  background-color: rgba(0, 0, 0, 0.4);
  border: 1px solid ${(props) => props.theme.colors.grayLighter};
  border-right-width: 0;
  position: absolute;
  right: 0;
  bottom: ${(props) => props.bottomOffset + props.theme.spacing.medium}px;
  width: ${(props) => props.theme.spacing.xxlarge * 2.5}px;
  padding: ${(props) => props.theme.spacing.small}px ${(props) => props.theme.spacing.smedium}px;
  user-select: none;
  color: ${(props) => props.theme.colors.grayLighter};
  font-size: ${(props) => props.theme.fontSizes.small}px;
  line-height: ${(props) => props.theme.fontSizes.larger * 1.1}px;
  text-align: center;
  flex-direction: row;
  align-items: center;
`

const SkipNowText = styled(Text)`
  font-size: ${(props) => props.theme.fontSizes.larger}px;
`

export const AdSkipControl = ({ skipConfig, onSkip, seekTime, bottomOffset }) => {
  const canSkip = !!skipConfig
  const time = Math.floor(seekTime)
  const skipAllowed = canSkip && time >= skipConfig.offset
  return (
    <Container
      bottomOffset={bottomOffset}
      onPress={skipAllowed ? onSkip : null}
      pointerEvents={skipAllowed ? 'auto' : 'none'}
    >
      {skipAllowed && (
        <>
          <SkipNowText>
            <FormattedMessage {...messages.skipAd} />
            &nbsp;&nbsp;
          </SkipNowText>
          <Icon name="skip-next" />
        </>
      )}
      {canSkip && !skipAllowed && (
        <Text>
          <FormattedMessage {...messages.skipAdIn} />
          {'\n'}
          <FormattedMessage
            {...messages.skipAdInSeconds}
            values={{ skipIn: skipConfig.offset - time }}
          />
        </Text>
      )}
      {!canSkip && (
        <Text>
          <FormattedMessage {...messages.playAfterAd} />
        </Text>
      )}
    </Container>
  )
}
